import { render, staticRenderFns } from "./MarketingMenu.vue?vue&type=template&id=505280e0&scoped=true"
import script from "./MarketingMenu.vue?vue&type=script&lang=js"
export * from "./MarketingMenu.vue?vue&type=script&lang=js"
import style0 from "./MarketingMenu.vue?vue&type=style&index=0&id=505280e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505280e0",
  null
  
)

export default component.exports